<form [formGroup]="opgaafFg">
  <ng-container formArrayName="opgaafSpecificaties">
    <ng-container *ngFor="let item of opgaafSpecificatie.controls; let i = index; trackBy: trackByFn"
                  [formGroupName]="i">
      <div class="row mb-1">
        <div class="col-auto">
          <snelstart-ui-text-form-control (change)="this.saveForm()"
                                          [label]="i === 0 ? 'Naam aandeelhouder' : ''"
                                          [required]=true
                                          class="custom-input-250"
                                          formControlName="naamGerechtigde"
                                          id="naamGerechtigde"
          >
          </snelstart-ui-text-form-control>
        </div>
        <div class="col-auto">
          <snelstart-ui-number-form-control (change)="this.saveForm()"
                                            [label]="i === 0 ? 'Aantal aandelen' : ''"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="bedragNominaalGestortKapitaal"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto">
          <snelstart-ui-number-form-control (change)="this.saveForm()"
                                            [label]="i === 0 ? 'Bedrag dividend' : ''"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="bedragVrijgesteldeUitkering"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto">
          <snelstart-ui-text-form-control (change)="this.saveForm()"
                                          [label]="i === 0 ? 'Fiscaal nummer' : ''"
                                          class="custom-input-150"
                                          formControlName="fiscaalNummerGerechtigde"
                                          id="fiscaalNummerGerechtigde"
          >
          </snelstart-ui-text-form-control>
        </div>
        <div class="col-auto">
          <snelstart-ui-button (click)="this.showDialog(i)"
                               [class]="i === 0 ? 'me-1 pt-3' : 'me-1'"
                               class="me-1"
                               icon="plus"
                               type="secondary">Meer gegevens
          </snelstart-ui-button>
        </div>
        <div class="col-auto">
          <snelstart-ui-button (click)="verwijderRij(i)"
                               [class]="i === 0 ? 'firstrowbutton' : ''"
                               icon="trash"
                               iconType="light"
                               id="buttonDelete"
                               size="medium"
                               type="secondary"
          >
          </snelstart-ui-button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</form>

<div *ngIf="opgaafSpecificatie.length === 0">
  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus" id="cancelA"
                       type="link">Gerechtigde invullen
  </snelstart-ui-button>
</div>
<div *ngIf="opgaafSpecificatie.length !== 0">
  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus" id="cancelB"
                       type="link">Gerechtigde toevoegen
  </snelstart-ui-button>
</div>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="aandeelhoudersGegevens" size="xl"
                                title="Gegevens aandeelhouder">
  <snelstart-ui-dialog-body>
    <form [formGroup]="opgaafFg">
      <div class="row">
        <ng-container formArrayName="opgaafSpecificaties">
          <ng-container *ngFor="let item of opgaafSpecificatie.controls; let i = index; trackBy: trackByFn"
                        [formGroupName]="i">
            <div *ngIf="i === this.index">
              <div>
                <snelstart-ui-text-form-control (change)="this.saveForm()"
                                                class="custom-input-100"
                                                formControlName="straatGerechtigde"
                                                id="straatGerechtigde"
                                                label="Straatnaam"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-text-form-control (change)="this.saveForm()"
                                                class="custom-input-60"
                                                formControlName="huisNummerGerechtigde"
                                                id="huisNummerGerechtigde"
                                                label="Nummer"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-text-form-control (change)="this.saveForm()"
                                                class="custom-input-75"
                                                formControlName="postCodeGerechtigde"
                                                id="postCodeGerechtigde"
                                                label="Postcode"
                >
                </snelstart-ui-text-form-control>
              </div>
              <div>
                <snelstart-ui-text-form-control (change)="this.saveForm()"
                                                [required]=true
                                                class="custom-input-250"
                                                formControlName="woonplaatsGerechtigde"
                                                label="Vestigingsplaats"
                >
                </snelstart-ui-text-form-control>
              </div>
              <div>
                <snelstart-ui-select-form-control (change)="this.saveForm()"
                                                  [options]="optionsLandcodes"
                                                  [required]=true
                                                  class="custom-input-250"
                                                  formControlName="landCode"
                                                  label="Vestigingsland"
                >
                </snelstart-ui-select-form-control>
              </div>
              <div>
                <snelstart-ui-number-form-control (change)="this.saveForm()"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-250"
                                                  formControlName="aantalStemgerechtigdeAandelen"
                                                  id="nominaleWaardeGewoneAandelen"
                                                  label="Aantal stemgerechtigde aandelen"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>
              <div>
                <snelstart-ui-number-form-control (change)="this.saveForm()"
                                                  [showAllDecimals]="true"
                                                  align="right"
                                                  class="custom-input-250"
                                                  formControlName="percentageStemrechten"
                                                  id="percentageStemrechten"
                                                  label="Percentage stemrechten"
                                                  prefix="%"
                >
                </snelstart-ui-number-form-control>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </form>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
    <snelstart-ui-button icon="check" id="save" type="primary">Akkoord</snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
